module.exports = __webpack_public_path__ + "static/media/q_nav_3_selected.e9b148ba.svg";